module.exports = __webpack_public_path__ + "img/icon-04.7951007d.png";